import React, {FunctionComponent} from "react";
import {ParticipantRating} from "/src/domain/challenges/ChallengeRatingData";
import ParticipantRow from "/src/ui/challengeClubRating/ParticipantRow";
import {Grid} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from "react-i18next";

interface RatingParticipantsData {
    ratingParticipants: ParticipantRating[];
    currentUserId?: string;
}

const RatingParticipants: FunctionComponent<RatingParticipantsData> = ({
                                                                           ratingParticipants,
                                                                           currentUserId
                                                                       }) => {
    const {t} = useTranslation()
    const classes = useStyles()
    return (
        <div className={classes.container}>
            <Grid container
                  justifyContent="center"
                  alignItems="center"
                  className={classes.participantHeader}
                  spacing={1}
            >
                <Grid item xs={1} className={classes.cell}>#</Grid>
                <Grid item xs={1} className={classes.cell}></Grid>
                <Grid item xs={6} className={classes.cell}>{t('name')}</Grid>
                <Grid item container justifyContent="flex-end" xs={3}
                      className={classes.cell}>{t('ratingPoints')}</Grid>
            </Grid>
            {
                ratingParticipants.map((participant) => (
                    <ParticipantRow
                        key={participant.id}
                        participant={participant}
                        currentUserId={currentUserId}
                    />
                ))
            }
        </div>
    );
}

const useStyles = makeStyles(muiTheme => ({
    container: {
        color: muiTheme.palette.primary.main,
        fontWeight: 500,
        fontSize: '0.8rem'
    },
    header: {
        fontSize: '1rem',
        fontWeight: 500,
        padding: '1.5rem 1.5rem 0.5rem'
    },
    participantHeader: {
        padding: '0.7rem 0',
        width: '100%',
        margin: 0,
    },
    cell: {
        overflowX: 'auto'
    },
    showMore: {
        marginTop: '1rem',
        textAlign: 'center',
        '&>a': {
            cursor: 'pointer'
        }
    },
    errorMessage: {
        marginTop: '0.5rem',
        textAlign: 'center'
    }
}))

export default RatingParticipants